// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1WJqj","emails":"CreateEditClinics_emails__2Q1Fb","emailTagLabel":"CreateEditClinics_emailTagLabel__3pOlp"};